module.exports = __webpack_public_path__ + "img/footer_behzisti_10.da57fe0b.svg";